/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from '../../../components/ComponentTitle';
import { ComponentSourcetitle } from '../../../components/ComponentSourcetitle';
import { ComponentPreloader } from '../../../components/ComponentPreloader';
import { useData1 } from '../data/useData1';
import { useData2 } from '../data/useData2';
import { useChart1 } from '../transformers/useChart1';
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from '../../../../charts/components/HighchartsChart';
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";

export const ComponentChart2: React.FC<{ context: ContextReport1 }> = (props) => {
  return <ul>
    <li><ComponentFootnote><ComponentTitle>Increasing demand on food and energy crops through economic and population growth as well as energy policies</ComponentTitle>​</ComponentFootnote></li>
    <li><ComponentFootnote><ComponentTitle>Change in use of arable land from food production to fuel production</ComponentTitle>​</ComponentFootnote></li>
    <li><ComponentFootnote><ComponentTitle>More People will depend to the existing food production area in the future</ComponentTitle>​</ComponentFootnote></li>
    <li><ComponentFootnote><ComponentTitle>Increasing demand causes the need of area expansion and yield improvement​</ComponentTitle>​</ComponentFootnote></li>
  </ul>
};
